(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name annualLeaveBidding.controller:AnnualLeaveBiddingCtrl
   *
   * @description
   *
   */
  angular
    .module('annualLeaveBidding')
    .directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})

    .controller('AnnualLeaveBiddingCtrl', AnnualLeaveBiddingCtrl);


  function AnnualLeaveBiddingCtrl(PopupManager,CommonMasterData,AnnualLeaveBiddingService,MessageService,  $http) {
    var vm = this;
    vm.ctrlName = 'AnnualLeaveBiddingCtrl';

    vm.model = {
            masterList: {
            	roleNameList:[],
            },
            initialSearchDone:false,
            annualLeaveBidding:{
              remarks : '',
              file : [],
            },
            filename:'',
            currentTime:'',
            uploadUrl:'',
            formData:null,
            bulkResponseList:[],
            resultList:[],
            loading:false,
            bulkUpdateFileNameForReference:'',
        };

    vm.uploadFile = function () {
      // vm.model.loading = true;
      vm.model.bulkResponseList = [];
      vm.model.filename = event.target.files[0];
      var currentTime = new Date();
      vm.model.currentTime = currentTime;
      vm.model.uploadUrl = "/admin/aeroLineCrewAdmin/crewingService/save/annualLeaveBidding";
      vm.model.formdata = new FormData();
      vm.model.formdata.append('fileMeta', vm.model.filename);

      $http.post(vm.model.uploadUrl, vm.model.formdata, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      })
        .success(function (response) {
          if(response.validationMessage != null) {
            vm.model.filename = '';
            var message = response.validationMessage;
            var details = {
              title: 'Upload Result',
              messages: [message]

            };
            PopupManager.openModal('INFO_DIALOG', details, locationreload);

            // locationreload();

          }else {
            MessageService.success(MessageService.MESSAGES.ANNUAL_LEAVE_BID.UPLOAD_SUCCESS);
            vm.model.bulkUpdateFileNameForReference = response.bulkUpdateFileNameForReference;
          }
        })

        .error(function (response) {
          MessageService.error(response.error);
        });

    };


    // $interval.cancel(angularInterval);

    vm.printInterval = function () {
      console.log("event run");
    }

    vm.saveCsvFile = function () {
      if(!angular.equals(vm.model.filename,'')) {
        $http.post(vm.model.uploadUrl, vm.model.formdata, {
          transformRequest: angular.identity,
          headers: {'Content-Type': undefined}
        })
          .success(function (response) {
            if(response.validationMessage!=null){
              vm.model.formdata = null;
              MessageService.error(response.validationMessage);
            }else{
              MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
              vm.model.bulkResponseList = response.assignDutyResponse;
            }

          })

          .error(function (response) {
            MessageService.error(response.error);
          });
      }else{
        MessageService.error(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
      }
    }

    vm.getResponseData = function () {
        if(!angular.equals(vm.model.filename,'')) {
          var param = {};
          param.bulkUpdateFileNameForReference = vm.model.bulkUpdateFileNameForReference;
          AnnualLeaveBiddingService.getAnnualLeaveBiddingResponse(param,
            function (response) {
              if (response.success) {
                if (response.assignDutyResponses != null) {
                  vm.model.bulkResponseList = response.assignDutyResponses.assignDutyResponse;
                  if (vm.model.bulkResponseList.length > 0) {
                    MessageService.success(MessageService.MESSAGES.ANNUAL_LEAVE_BID.RESPONSE_SUCCESS);
                    downloadCsv();
                  }

                } else {
                  var message = "Leave update still in progress. Search again after some time.";
                  var details = {
                    title: 'Search Response',
                    messages: [message]

                  };
                  PopupManager.openModal('INFO_DIALOG', details);

                }

              } else {
                MessageService.error(response.errors[0]);
              }
            },
            function (error) {
              MessageService.error(error);
            }
          );
        }else{
          MessageService.error(MessageService.MESSAGES.ANNUAL_LEAVE_BID.RESPONSE_CLICK_BEFORE_UPLOAD_FILE);

        }
    }



    vm.exportResultAsCsv = function () {
      downloadCsv();
    };

    function downloadCsv(){
      if(vm.model.bulkResponseList.length>0) {
        createResponseList();
        alasql("SELECT bulkUpdateCrewId as [Crew Id],bulkUpdateLeaveType as [Leave Type],bulkUpdateFromDate as [From Date],bulkUpdateToDate as [To Date],[success] as [success] INTO XLSX('annualLeaveBiddingBulkUpdateResult.xlsx',{headers:true}) FROM ? ", [vm.model.resultList]);
        clearData();
      }
    }

    function createResponseList() {
      for (var i = 0; i < vm.model.bulkResponseList.length; i++) {
        var resultList = [];

        resultList.bulkUpdateCrewId = vm.model.bulkResponseList[i].bulkUpdateCrewId;
        resultList.bulkUpdateLeaveType = vm.model.bulkResponseList[i].bulkUpdateLeaveType;
        resultList.bulkUpdateFromDate = vm.model.bulkResponseList[i].bulkUpdateFromDate;
        resultList.bulkUpdateToDate = vm.model.bulkResponseList[i].bulkUpdateToDate;
        resultList.bulkUpdateValidationResult = vm.model.bulkResponseList[i].bulkUpdateValidationResult;
        resultList.otherBlockIllegal = vm.model.bulkResponseList[i].otherBlockIllegal;
        resultList.regulationMap = vm.model.bulkResponseList[i].regulationMap;
        resultList.success = vm.model.bulkResponseList[i].success;

        vm.model.resultList.push(resultList);
      }

    };

    function clearData(){
      vm.model.resultList = [];
    }

    function locationreload(pass) {
      if(pass==='YES') {
        location.reload();
      }

    }

  }
}());
